import { h, F as Fragment, r as registerInstance, c as createEvent, f as forceUpdate, H as Host } from './index-ih07wrgW.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-ddkg-Itl.js';
import { g as getSoftwares, a as getSoftwareTypes, b as getErrorNumberRegexForTechnology, S as SOFTWARE_TYPES, c as getSoftwareModulesByType, d as getApplicationOptionsFromForm, e as createRequestData } from './createCase-BGqTFsuJ.js';
import { g as getAuthClient, a as authClientName, A as ApiClient, s as setEnv, b as getEnvConfig, c as getPublicApiClient } from './publicApiClient-C-YZFxlI.js';
import { c as createStore, a as createAuthStore, w as whenAuthenticated, S as SilentAuth } from './auth-C0IsRTrr.js';

const FormSteps = ({ multipleSteps }, children) => {
    if (!multipleSteps)
        return children;
    return h("ux-form-steps", null, children);
};
const FormStep = ({ multipleSteps }, children) => {
    if (!multipleSteps)
        return children;
    return h("ux-form-step", null, children);
};
const StepNavigation = ({ t, multipleSteps, currentStep }) => multipleSteps ? (h("div", { class: "ux-u-margin-top-40 ux-u-margin-bottom-40", style: { "min-height": "87px" } },
    h("ux-steps", null,
        h("ux-steps-item", { "data-ux-form-steps-prev": currentStep === 2 ? true : undefined, number: 1, current: currentStep === 1, done: currentStep === 2 }, t("headline.caseDetails")),
        h("ux-steps-item", { number: 2, current: currentStep === 2, "data-ux-form-steps-next": currentStep === 1 ? true : undefined }, t("headline.contactData"))))) : null;
const StepNext = ({ t, multipleSteps, onCancel }) => multipleSteps ? (h("div", { class: "ux-row" },
    h("div", { class: "ux-col-12 ux-u-margin-bottom-20" },
        h("div", { class: "ux-text-normal ux-text-normal--light-gray" },
            h("p", null, t("validation.requiredFieldsExplanation")))),
    h("div", { class: "ux-col-12" },
        h("div", { class: "ux-u-d-flex ux-u-flex-jc-between ux-u-flex-dir-row-reverse" },
            h("ux-button", { "data-ux-form-steps-next": true, variant: "primary" }, t("button.next")),
            h("ux-button", { type: "button", onClick: () => onCancel() }, t("button.cancel")))))) : null;
const StepBack = ({ t, multipleSteps }) => multipleSteps ? (h("ux-button", { "data-ux-form-steps-prev": true, type: "button" }, t("button.back"))) : null;

/**
 * Decodes a JWT token to an object
 * implementation from https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
 * @param token JWT token
 * @returns object
 */
function decodeJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""));
    return JSON.parse(jsonPayload);
}

const getAssets = async (apiClient) => {
    const idToken = getAuthClient(authClientName).getIdToken();
    const decoded = decodeJwt(idToken);
    const { customerNumber } = decoded;
    return apiClient
        .request(`/asset-management/1.0/core/assets/parameters?customerOrgId=${customerNumber}&isCustomOnly=false&isRootAsset=true`, {
        method: "GET",
        mockResponse
    })
        .then((response) => {
        if (response.assets) {
            return response.assets;
        }
        return Promise.reject("No assets found");
    });
};
const mockResponse = {
    assets: [
        {
            assetId: "A0660A0576",
            assetName: "Quicksharp",
            technologyId: "PUNCHING"
        },
        {
            assetId: "LS00093708",
            assetName: "HL 54P",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0551A0120",
            assetName: "HL 101P",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "LS00009160",
            assetName: "HL 2006D",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "LS00093844",
            assetName: "HL 2006D",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "N0053A0020",
            assetName: "SortMaster (AL28)",
            technologyId: "AUTOMATION"
        },
        {
            assetId: "C0200I0005",
            assetName: "Toolshuttle",
            technologyId: "AUTOMATION"
        },
        {
            assetId: "883850",
            assetName: "TRBV85SX",
            technologyId: "BENDING"
        },
        {
            assetId: "B0501A0185",
            assetName: "TruBend 5050",
            technologyId: "BENDING"
        },
        {
            assetId: "B1503I0001",
            assetName: "TruBend 5085 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1504I0151",
            assetName: "TruBend 5130 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1505I0280",
            assetName: "TruBend 5170 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1505I0637",
            assetName: "TruBend 5170 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1507I0001",
            assetName: "TruBend 5230 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B1509I0001",
            assetName: "TruBend 5320 (B23)",
            technologyId: "BENDING"
        },
        {
            assetId: "B0702A2028",
            assetName: "TruBend 7036",
            technologyId: "BENDING"
        },
        {
            assetId: "B0702A2031",
            assetName: "TruBend 7036",
            technologyId: "BENDING"
        },
        {
            assetId: "B1703I0086",
            assetName: "TruBend 7050 (B28)",
            technologyId: "BENDING"
        },
        {
            assetId: "E0953A0235",
            assetName: "TruDisk 2001 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E0953A0078",
            assetName: "TruDisk 4002 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1153A0485",
            assetName: "TruDisk 4002 (4C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1153A0426",
            assetName: "TruDisk 6602 (4 C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E0953A0227",
            assetName: "TruDisk 8002 (2C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "E1053A0162",
            assetName: "TruDisk  3001 (4 C)",
            technologyId: "DISKLASER"
        },
        {
            assetId: "A0221E0833",
            assetName: "TruLaser 3030 fiber (L49)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0221E1065",
            assetName: "TruLaser 3030 fiber (L49)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A2221E0146",
            assetName: "TruLaser 3030 fiber (L95)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A3231E0025",
            assetName: "TruLaser 5030 fiber (L76)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A3231E0518",
            assetName: "TruLaser 5030 fiber (L76)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "S2321M0144",
            assetName: "TruLaser Cell 3000 (L34)",
            technologyId: "WELDING"
        },
        {
            assetId: "S0541C0287",
            assetName: "TruLaser Cell 7040 (L31) fiber",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "S0541C0328",
            assetName: "TruLaser Cell 7040 (L31) fiber",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "A0280E0038",
            assetName: "TruLaser Center 7030 (L26)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0280E0127",
            assetName: "TruLaser Center 7030 (L26)",
            technologyId: "2DLASERCUTTING"
        },
        {
            assetId: "A0455A0024",
            assetName: "TruLaser Robot 5020",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A0455A0037",
            assetName: "TruLaser Robot 5020",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A1441D0079",
            assetName: "TruLaser Tube 7000 fiber",
            technologyId: "LASERTUBECUTTING"
        },
        {
            assetId: "A0150A0160",
            assetName: "TruMatic 7000",
            technologyId: "COMBINED"
        },
        {
            assetId: "A1150D0126",
            assetName: "TruMatic 7000 (K08) Medium format",
            technologyId: "COMBINED"
        },
        {
            assetId: "A0460A0004",
            assetName: "TrumaWeld L 1000",
            technologyId: "WELDING"
        },
        {
            assetId: "A0420A0232",
            assetName: "TRUMPF Lasercell 1005",
            technologyId: "3DLASERCUTTING"
        },
        {
            assetId: "S0711Q0095",
            assetName: "TruPrint 1000 (G01)",
            technologyId: "3DPRINTING"
        },
        {
            assetId: "E0851A0036",
            assetName: "TruPulse 203",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0851A0048",
            assetName: "TruPulse 556",
            technologyId: "PULSEDLASER"
        },
        {
            assetId: "E0652A0387",
            assetName: "VectorMark Compact 1",
            technologyId: "MARKINGLASER"
        }
    ]
};

const getNotificationTypes = async (apiClient) => {
    return apiClient.request("/servicecall/getnotificationtypes", {
        mockResponse: mockNotificationTypes
    });
};
const NOTIFICATION_TYPES = {
    MACHINE_STOP: 20,
    FAULT_WITHOUT_STOP: 10,
    PROGRAMMING_SOFTWARE: -100,
    CLARIFICATION_SPARE_PARTS: 50,
    OTHER: 40,
    MAINTENANCE_REQUEST: 120,
    SPARE_PARTS_ORDER: 140,
    APPLICATION_ISSUES: 80
};
const mockNotificationTypes = [
    {
        Id: NOTIFICATION_TYPES.MACHINE_STOP,
        LabelKey: "Maschinenstillstand"
    },
    {
        Id: NOTIFICATION_TYPES.FAULT_WITHOUT_STOP,
        LabelKey: "Störung ohne Stillstand"
    },
    {
        Id: NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE,
        LabelKey: "Programmierung / Software"
    },
    {
        Id: NOTIFICATION_TYPES.CLARIFICATION_SPARE_PARTS,
        LabelKey: "Klärung Ersatzteile"
    },
    {
        Id: NOTIFICATION_TYPES.OTHER,
        LabelKey: "Sonstiges"
    },
    {
        Id: NOTIFICATION_TYPES.MAINTENANCE_REQUEST,
        LabelKey: "Wartungsanfrage"
    },
    {
        Id: NOTIFICATION_TYPES.SPARE_PARTS_ORDER,
        LabelKey: "Bestellung Ersatzteile"
    },
    {
        Id: NOTIFICATION_TYPES.APPLICATION_ISSUES,
        LabelKey: "Applikationsthemen"
    }
];

const getUserDetails = async (apiClient) => {
    return apiClient.request("/user/getuserdetails", {
        mockResponse: mockUserDetails
    });
};
const mockUserDetails = {
    userId: "ServiceDE",
    salutation: "2",
    title: null,
    firstname: "Marc",
    surname: "Wenzler",
    email: "Marc.Wenzler.DEMO_TWDE1@de.trumpf.com",
    phone: "+49715630334317",
    fax: null,
    position: "Testuser Service App deutsch",
    language: "de",
    customerNo: "270763",
    company: "MyTRUMPF DEMO DE",
    street: "Johann-Maus-Straße 2",
    zipCode: "71254",
    city: "Ditzingen",
    state: null,
    country: "DE",
    status: "Activated",
    customerAdmin: "false",
    userRoles: ["confirmed", "service_full", "order_use", "order_read", "service_read", "order_full", "customer"]
};

const mapUserDetailsToContactInfo = (userDetails) => {
    return {
        salutation: getSalutation(userDetails.salutation),
        firstName: userDetails.firstname,
        lastName: userDetails.surname,
        email: userDetails.email,
        phone: userDetails.phone
    };
};
const getSalutation = (salutation) => {
    if (typeof salutation === "string") {
        const parsed = parseInt(salutation, 10);
        return isNaN(parsed) ? null : parsed;
    }
    return null;
};

/**
 * Fetch application topic options from the API.
 * @param apiClient PublicApiClient instance to make the request
 * @param country string | null - The country for which to fetch application topic options
 * The API will return options based on the provided country. for some countries, it may return an empty array.
 * @returns ApplicationTopicOptions
 */
const getApplicationTopicOptions = async (apiClient, country) => {
    return apiClient.request("/servicecall/getapplicationtopicoptions", {
        mockResponse: mockApplicationTopicOptions,
        body: { country }
    });
};
const mockApplicationTopicOptions = [
    {
        name: "Applikation",
        children: [
            {
                id: 1,
                name: "Schweißen",
                children: [
                    {
                        name: "Optik",
                        children: [
                            {
                                id: 7,
                                name: "Festoptik BEO"
                            },
                            {
                                id: 8,
                                name: "PFO20/33"
                            },
                            {
                                id: 9,
                                name: "PFO 3D"
                            },
                            {
                                id: 10,
                                name: "I-PFO"
                            },
                            {
                                id: 11,
                                name: "Sonstiges"
                            }
                        ]
                    },
                    {
                        name: "Applikationsproblem",
                        children: [
                            {
                                id: 12,
                                name: "Einschweißtiefe"
                            },
                            {
                                id: 13,
                                name: "Festigkeit"
                            },
                            {
                                id: 14,
                                name: "Rissbildung"
                            },
                            {
                                id: 15,
                                name: "Lunker/Spritzer"
                            },
                            {
                                id: 16,
                                name: "Prozessdaten"
                            },
                            {
                                id: 17,
                                name: "Sonstiges"
                            }
                        ]
                    }
                ]
            },
            {
                id: 2,
                name: "Kunststoff"
            },
            {
                id: 3,
                name: "Schneiden"
            },
            {
                id: 4,
                name: "Härten"
            },
            {
                id: 5,
                name: "Beschriften"
            },
            {
                id: 6,
                name: "Sonstiges"
            }
        ]
    }
];

const createApiStore = () => {
    const store = createStore({
        machinesLoading: true,
        machines: [],
        softwaresLoading: true,
        softwares: [],
        softwareTypes: [],
        applicationTopicOptionsLoading: true,
        applicationTopicOptions: [],
        notificationTypesLoading: true,
        notificationTypes: [],
        userDetailsLoading: true,
        country: null,
        contactInfo: null,
        isAllowedToCreateCase: null,
        loading: true
    });
    store.onChange("machinesLoading", () => updateLoading());
    store.onChange("softwaresLoading", () => updateLoading());
    store.onChange("notificationTypesLoading", () => updateLoading());
    store.onChange("userDetailsLoading", () => updateLoading());
    store.onChange("applicationTopicOptionsLoading", () => updateLoading());
    function updateLoading() {
        const { machinesLoading, softwaresLoading, notificationTypesLoading, userDetailsLoading, applicationTopicOptionsLoading } = store.state;
        store.state.loading =
            machinesLoading || softwaresLoading || notificationTypesLoading || userDetailsLoading || applicationTopicOptionsLoading;
    }
    return store;
};
const loadFormDataFromPublicApi = async (apiStore, apiClient) => {
    apiStore.state.softwaresLoading = true;
    apiStore.state.notificationTypesLoading = true;
    getSoftwares(apiClient).then((softwares) => {
        apiStore.state.softwares = softwares;
        apiStore.state.softwareTypes = getSoftwareTypes(softwares);
        apiStore.state.softwaresLoading = false;
    });
    getNotificationTypes(apiClient).then((notificationTypes) => {
        apiStore.state.notificationTypes = notificationTypes;
        apiStore.state.notificationTypesLoading = false;
    });
    getUserDetails(apiClient).then((userDetails) => {
        var _a;
        apiStore.state.contactInfo = mapUserDetailsToContactInfo(userDetails);
        apiStore.state.isAllowedToCreateCase = ((_a = userDetails.userRoles) === null || _a === void 0 ? void 0 : _a.includes("service_full")) || false;
        apiStore.state.country = userDetails.country;
        apiStore.state.userDetailsLoading = false;
    });
    apiStore.onChange("userDetailsLoading", () => {
        const { country } = apiStore.state;
        getApplicationTopicOptions(apiClient, country).then((applicationTopicOptions) => {
            apiStore.state.applicationTopicOptions = applicationTopicOptions;
            apiStore.state.applicationTopicOptionsLoading = false;
        });
    });
};
const loadFormDataFromAssetManagementApi = async (apiStore, apiClient) => {
    apiStore.state.machinesLoading = true;
    getAssets(apiClient).then((machines) => {
        apiStore.state.machines = machines;
        apiStore.state.machinesLoading = false;
    });
};

const hideMachinesForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showErrorNumbersForNotificationTypes = [
    null,
    NOTIFICATION_TYPES.APPLICATION_ISSUES,
    NOTIFICATION_TYPES.MACHINE_STOP,
    NOTIFICATION_TYPES.FAULT_WITHOUT_STOP
];
const hideErrorNumbersForTechnologies = [];
const showSoftwareFieldsForNotificationTypes = [NOTIFICATION_TYPES.PROGRAMMING_SOFTWARE];
const showSoftwareModulesForSoftwareTypes = [SOFTWARE_TYPES.TRUTOPS, SOFTWARE_TYPES.TRUTOPS_FAB, SOFTWARE_TYPES.TRUTOPS_BOOST];
const showApplicationIssuesForNotificationTypes = [NOTIFICATION_TYPES.APPLICATION_ISSUES];
const showApplicationIssuesForTechnologies = [
    "PULSEDLASER",
    "SHORTPULSEDLASER",
    "DISKLASER",
    "FIBERLASER",
    "DIODELASER",
    "MARKINGLASER"
];
const createFormStore = () => {
    const store = createStore({
        selectedNotificationType: null,
        selectedSoftwareType: null,
        formIsSubmitted: false,
        selectedMachineTechnology: null,
        selectedApplications: [],
        showErrorNumbers: true,
        showApplications: false,
        showSoftwareModules: false,
        showMachines: true,
        showSoftwareFields: false,
        errorNumberRegex: getErrorNumberRegexForTechnology()
    });
    store.onChange("selectedNotificationType", (selectedNotificationType) => {
        store.state.showMachines = !hideMachinesForNotificationTypes.includes(selectedNotificationType);
        store.state.showSoftwareFields = showSoftwareFieldsForNotificationTypes.includes(selectedNotificationType);
        determineShowErrorNumbers();
        determineShowApplications();
    });
    store.onChange("selectedMachineTechnology", () => {
        determineShowErrorNumbers();
        determineShowApplications();
        determineErrorNumberRegex();
    });
    store.onChange("selectedSoftwareType", (selectedSoftwareType) => {
        store.state.showSoftwareModules = showSoftwareModulesForSoftwareTypes.includes(selectedSoftwareType);
    });
    function determineShowApplications() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showApplications =
            showApplicationIssuesForNotificationTypes.includes(selectedNotificationType) &&
                showApplicationIssuesForTechnologies.includes(selectedMachineTechnology);
    }
    function determineErrorNumberRegex() {
        const { selectedMachineTechnology } = store.state;
        store.state.errorNumberRegex = getErrorNumberRegexForTechnology(selectedMachineTechnology);
    }
    function determineShowErrorNumbers() {
        const { selectedNotificationType, selectedMachineTechnology } = store.state;
        store.state.showErrorNumbers =
            showErrorNumbersForNotificationTypes.includes(selectedNotificationType) &&
                !(selectedMachineTechnology !== null && hideErrorNumbersForTechnologies.includes(selectedMachineTechnology));
    }
    return store;
};

const ErrorNumberInput = ({ t, prefillData, formStore }) => {
    var _a, _b, _c, _d;
    return (h("div", { class: "ux-u-margin-bottom-20" },
        h("label", { class: "ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase" }, t("field.errorNumber.label")),
        h("service-calls-dynamic-input", { "add-text": `+ ${t("field.errorNumber.addAnotherNumber")}`, "input-name": "errorNumber1", prefilledValues: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.errorNumbers) || [], "init-items": ((_c = (_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _b === void 0 ? void 0 : _b.errorNumbers) === null || _c === void 0 ? void 0 : _c.length) || 1, "min-items": "1", "max-items": "6", disabled: !!((_d = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _d === void 0 ? void 0 : _d.errorNumbers), regex: formStore.state.errorNumberRegex, "error-message": t("field.errorNumber.errorMessage") },
            h("div", { class: "mf-create-service-case__help-block", slot: "info" },
                h("p", { class: "ux-text-tiny" }, t("field.errorNumber.explanation"))))));
};

const SALUTATION = {
    FEMALE: 1,
    MALE: 2
};

const getLanguageFromLocale = (locale) => {
    if (!locale.includes("-")) {
        return locale;
    }
    return locale.split("-")[0];
};
const getCountryFromLocale = (locale) => {
    if (!locale.includes("-")) {
        return null;
    }
    return locale.split("-")[1];
};

const SalutationInput = ({ t, apiStore }) => {
    var _a, _b, _c;
    return (h("ux-select", { label: t("field.salutation.label"), required: true, name: "salutation" },
        h("option", { value: "", selected: typeof ((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.salutation) !== "number", disabled: true }, t("select.placeholder")),
        h("option", { value: SALUTATION.FEMALE, selected: ((_b = apiStore.state.contactInfo) === null || _b === void 0 ? void 0 : _b.salutation) === SALUTATION.FEMALE }, t("field.salutation.female")),
        h("option", { value: SALUTATION.MALE, selected: ((_c = apiStore.state.contactInfo) === null || _c === void 0 ? void 0 : _c.salutation) === SALUTATION.MALE }, t("field.salutation.male"))));
};
const FirstNameInput = ({ t, apiStore }) => {
    var _a;
    return (h("ux-input-field", { "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "45", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 45
        }), label: t("field.firstName.label"), name: "firstName", value: ((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.firstName) || "", required: true }));
};
const LastNameInput = ({ t, apiStore }) => {
    var _a;
    return (h("ux-input-field", { "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "45", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 45
        }), label: t("field.lastName.label"), name: "lastName", value: ((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.lastName) || "", required: true }));
};
const PhoneInput = ({ t, apiStore, locale }) => {
    var _a, _b;
    return (h("ux-phone-input", { key: t("validation.requiredField"), label: t("field.phone.label"), language: getLanguageFromLocale(locale), country: !((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.phone) ? getCountryFromLocale(locale) : undefined, "data-validation-invalid--msg": t("validation.invalidPhoneNumber"), "data-validation-required--msg": t("validation.requiredField"), name: "phone", value: ((_b = apiStore.state.contactInfo) === null || _b === void 0 ? void 0 : _b.phone) || "", required: true }));
};
const EmailInput = ({ t, apiStore }) => {
    var _a;
    return (h("ux-input-field", { type: "email", required: true, "data-validation-required--msg": t("validation.requiredField"), "data-validation-length--max": "100", "data-validation-length--msg": t("validation.maxAllowedCharacters", {
            number: 100
        }), "data-validation-invalid--msg": t("validation.invalidEmail"), label: "E-Mail", name: "email", value: ((_a = apiStore.state.contactInfo) === null || _a === void 0 ? void 0 : _a.email) || "" }));
};
const ContactInputs = ({ t, apiStore, locale }) => (h(Fragment, null,
    h("div", { class: "ux-row" },
        h("div", { class: "ux-col-12 ux-col-md-6" },
            h("div", { class: "ux-u-margin-bottom-20" },
                h(SalutationInput, { t: t, apiStore: apiStore })))),
    h("div", { class: "ux-row" },
        h("div", { class: "ux-col-12 ux-col-md-6" },
            h("div", { class: "ux-u-margin-bottom-20" },
                h(FirstNameInput, { t: t, apiStore: apiStore }))),
        h("div", { class: "ux-col-12 ux-col-md-6" },
            h("div", { class: "ux-u-margin-bottom-20" },
                h(LastNameInput, { t: t, apiStore: apiStore })))),
    h("div", { class: "ux-row" },
        h("div", { class: "ux-col-12 ux-col-md-6" },
            h("div", { class: "ux-u-margin-bottom-20" },
                h(PhoneInput, { t: t, apiStore: apiStore, locale: locale }))),
        h("div", { class: "ux-col-12 ux-col-md-6" },
            h("div", { class: "ux-u-margin-bottom-20" },
                h(EmailInput, { t: t, apiStore: apiStore }))))));

const classifications = ["standstill", "fault", "slightImpairment", "generalInquiry"];

const SoftwareModuleSelect = ({ t, prefillData, formStore, apiStore }) => {
    var _a, _b;
    return (h("ux-select", { required: true, label: t("field.softwareModule.label"), "data-validation-required--msg": t("validation.requiredField"), name: "softwareModule", disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareModule },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.softwareModule), disabled: true }, t("select.placeholder")),
        getSoftwareModulesByType(apiStore.state.softwares, formStore.state.selectedSoftwareType).map((softwareModule) => {
            var _a;
            return (h("option", { value: softwareModule, selected: softwareModule === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareModule) }, softwareModule));
        })));
};
const SoftwareTypeSelect = ({ t, prefillData, formStore, apiStore }) => {
    var _a, _b;
    return (h("ux-select", { required: true, label: t("field.softwareType.label"), name: "softwareType", onUxChange: (event) => {
            formStore.state.selectedSoftwareType = event.detail.value;
        }, disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareType },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.softwareType), disabled: true }, t("select.placeholder")),
        apiStore.state.softwareTypes.map((softwareType) => {
            var _a;
            return (h("option", { value: softwareType, selected: ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareType) === softwareType }, softwareType));
        })));
};
const SoftwareClassificationSelect = ({ t, prefillData }) => {
    var _a;
    const hasPrefilledClassification = classifications.includes((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareProblemClassification);
    return (h("ux-select", { required: true, label: t("field.softwareProblemClassification.label"), "data-validation-required--msg": t("validation.requiredField"), name: "softwareProblemClassification" },
        h("option", { value: "", selected: !hasPrefilledClassification, disabled: true }, t("select.placeholder")),
        classifications.map((classification) => {
            var _a;
            return (h("option", { value: classification, selected: classification === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.softwareProblemClassification) }, t(`softwareProblemClassification.${classification}`)));
        })));
};
const InstallationCheckbox = ({ t, prefillData }) => {
    var _a, _b;
    return (h("ux-checkbox", { label: t("field.softwareInstallationProblem.label"), name: "installationProblem", checked: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.isInstallationProblem, disabled: typeof ((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.isInstallationProblem) === "boolean" }));
};
const LicenseCheckbox = ({ t, prefillData }) => {
    var _a, _b;
    return (h("ux-checkbox", { label: t("field.softwareLicenseIssue.label"), name: "licenseIssue", checked: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _a === void 0 ? void 0 : _a.isLicenseIssue, disabled: typeof ((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.softwareData) === null || _b === void 0 ? void 0 : _b.isLicenseIssue) === "boolean" }));
};
const SoftwareInputs = ({ t, prefillData, formStore, apiStore }) => {
    const { showSoftwareModules, showSoftwareFields } = formStore.state;
    if (!showSoftwareFields) {
        return null;
    }
    return (h(Fragment, null,
        h("div", { class: "ux-row" },
            h("div", { class: "ux-col-12 ux-col-md-6" },
                h("div", { class: "ux-u-margin-bottom-20" },
                    h(SoftwareClassificationSelect, { t: t, prefillData: prefillData })))),
        h("div", { class: "ux-row" },
            h("div", { class: "ux-col-12 ux-col-md-6" },
                h("div", { class: "ux-u-margin-bottom-20" },
                    h(InstallationCheckbox, { t: t, prefillData: prefillData }))),
            h("div", { class: "ux-col-12 ux-col-md-6" },
                h("div", { class: "ux-u-margin-bottom-20" },
                    h(LicenseCheckbox, { t: t, prefillData: prefillData })))),
        h("div", { class: "ux-row" },
            h("div", { class: "ux-col-12 ux-col-md-6" },
                h("div", { class: "ux-u-margin-bottom-20" },
                    h(SoftwareTypeSelect, { t: t, prefillData: prefillData, formStore: formStore, apiStore: apiStore }))),
            showSoftwareModules && (h("div", { class: "ux-col-12 ux-col-md-6" },
                h("div", { class: "ux-u-margin-bottom-20" })))),
        h("div", { class: "ux-row" }, showSoftwareModules && (h("div", { class: "ux-col-12 ux-col-md-6" },
            h("div", { class: "ux-u-margin-bottom-20" },
                h(SoftwareModuleSelect, { t: t, prefillData: prefillData, formStore: formStore, apiStore: apiStore })))))));
};

const getSelectedSubApplications = (formStore, applicationTopicGroup) => {
    const selectedApplications = formStore.state.selectedApplications || [];
    const subApplications = [];
    applicationTopicGroup.children
        .filter((application) => selectedApplications.includes(application.id))
        .map((application) => { var _a; return (_a = application.children) === null || _a === void 0 ? void 0 : _a.forEach((group) => subApplications.push(group)); });
    return subApplications;
};

const ApplicationSelect = ({ t, applicationTopicGroup, formStore, form, prefillData }) => (h("ux-select", { required: true, label: applicationTopicGroup.name, "data-validation-required--msg": t("validation.requiredField"), name: "application", onUxChange: () => {
        formStore.state.selectedApplications = getApplicationOptionsFromForm(form);
    } },
    h("option", { value: "", selected: true, disabled: true }, t("select.placeholder")),
    applicationTopicGroup.children.map((application) => {
        var _a;
        return (h("option", { value: application.id, selected: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.applicationTopicIds) === null || _a === void 0 ? void 0 : _a.includes(application.id) }, application.name));
    })));
const ApplicationSelectGroup = ({ t, apiStore, formStore, form, prefillData }) => {
    if (!formStore.state.showApplications) {
        return null;
    }
    return apiStore.state.applicationTopicOptions.map((applicationTopicGroup) => (h(Fragment, null,
        h("div", { class: "ux-row" },
            h("div", { class: "ux-col-12 ux-col-md-6" },
                h("div", { class: "ux-u-margin-bottom-20" },
                    h(ApplicationSelect, { t: t, applicationTopicGroup: applicationTopicGroup, formStore: formStore, form: form, prefillData: prefillData })))),
        h("div", { class: "ux-row" }, getSelectedSubApplications(formStore, applicationTopicGroup).map((subApplication) => (h("div", { class: "ux-col-12 ux-col-md-6" },
            h("div", { class: "ux-u-margin-bottom-20" },
                h(ApplicationSelect, { t: t, applicationTopicGroup: subApplication, formStore: formStore, form: form, prefillData: prefillData })))))))));
};

const MachineSelect = ({ t, prefillData, apiStore, formStore }) => {
    var _a, _b;
    const { machines } = apiStore.state;
    return (h("ux-select", { required: true, label: t("field.machine.label"), "data-validation-required--msg": t("validation.requiredField"), name: "productNo", onUxChange: (event) => {
            const machine = machines.find(({ assetId }) => assetId === event.detail.value);
            if (machine) {
                formStore.state.selectedMachineTechnology = machine.technologyId;
                return;
            }
            // eslint-disable-next-line no-console
            console.error(`Machine with id ${event.detail.value} not found`);
        }, disabled: (_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.assetId },
        h("option", { value: "", selected: !((_b = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _b === void 0 ? void 0 : _b.assetId), disabled: true }, t("select.placeholder")),
        machines.map((machine) => {
            var _a;
            return (h("option", { key: machine.assetId, value: machine.assetId, selected: machine.assetId === ((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.productData) === null || _a === void 0 ? void 0 : _a.assetId) },
                machine.assetName,
                " (",
                machine.assetId,
                ")"));
        })));
};

const NotificationTypeSelect = ({ t, prefillData, apiStore, formStore }) => {
    const { notificationTypes } = apiStore.state;
    const { selectedNotificationType } = formStore.state;
    return (h("ux-select", { required: true, label: t("field.reason.label"), "data-validation-required--msg": t("validation.requiredField"), name: "notificationType", onUxChange: (event) => {
            formStore.state.selectedNotificationType = Number(event.detail.value);
        }, disabled: prefillData === null || prefillData === void 0 ? void 0 : prefillData.notificationType },
        h("option", { value: "", selected: !(prefillData === null || prefillData === void 0 ? void 0 : prefillData.notificationType), disabled: true }, t("select.placeholder")),
        notificationTypes.map((notificationType) => (h("option", { key: String(notificationType.LabelKey), value: notificationType.Id, selected: notificationType.Id === selectedNotificationType }, notificationType.LabelKey)))));
};

const assetManagementApiClients = {};
const getAssetManagementApiClient = (config) => {
    const { assetManagementApiBaseUrl, authIssuer, authScope, authClientId } = config;
    const key = `${assetManagementApiBaseUrl}-${authIssuer}-${authScope}-${authClientId}`;
    if (!assetManagementApiClients[key]) {
        assetManagementApiClients[key] = new AssetManagementApiClient(config);
    }
    return assetManagementApiClients[key];
};
class AssetManagementApiClient extends ApiClient {
    /**
     * Request function to send an authenticated POST request to the AssetManagementAPI
     */
    async request(path, options) {
        if (this.config.useMockData) {
            return this.mockRequest(options === null || options === void 0 ? void 0 : options.mockResponse);
        }
        if (this.authClientServiceCalls === null) {
            return Promise.reject("AuthClient not initialized");
        }
        const { method = "POST", headers: additionalHeaders = {}, body: bodyObject } = options || {};
        const headers = Object.assign({ Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${this.token}` }, additionalHeaders);
        const body = bodyObject ? JSON.stringify(bodyObject) : undefined;
        return fetch(`${this.config.assetManagementApiBaseUrl}${path}`, {
            method,
            headers,
            body
        }).then((response) => {
            if (response.status === 401) {
                this.authClientServiceCalls.deleteAccessToken();
                return Promise.reject("Unauthorized");
            }
            if (response.status === 200) {
                return response.json();
            }
            return Promise.reject(`Error ${response.status}`);
        });
    }
}

const DescriptionInput = ({ t, prefillData }) => (h("ux-textarea-field", { label: t("field.message.label"), placeholder: t("field.message.placeholder"), value: (prefillData === null || prefillData === void 0 ? void 0 : prefillData.description) || "", required: true, "data-validation-required--msg": t("validation.requiredField"), name: "description" }));

const createServiceCaseCss = ".mf-create-service-case{display:block}.mf-create-service-case__button-group{display:flex;gap:0 10px;}mf-create-service-case ux-select{width:100%}";

const MfCreateServiceCase = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.serviceCaseSubmit = createEvent(this, "mfServiceCaseSubmit");
        this.serviceCaseCancel = createEvent(this, "mfServiceCaseCancel");
        /**
         * If true, the form will be displayed in multiple steps
         */
        this.multipleSteps = false;
        /**
         * Enable file upload in the form
         */
        this.fileUpload = false;
        /**
         * Data that should be prefilled in the form
         * @optional
         */
        this.prefillData = null;
        /**
         * Application name that will be used as origin of the source when sending the form.
         * This can be overridden by the prefillData.origin
         */
        this.origin = "";
        /**
         * The locale to use for translations and the phone input
         */
        this.locale = "en-US";
        /**
         * Environment string to decide which endpoints to use
         */
        this.env = "prod";
        /**
         * use onprem Public API instead of azure
         * @deprecated only used until April 2025
         */
        this.legacyApi = false;
        /**
         * disable silent auth - then the application needs to supply the auth token via @trumpf/ux.utils
         * @optional
         */
        this.disableSilentAuth = false;
        this.tbdbError = null;
        this.apiStore = createApiStore();
        this.authStore = createAuthStore();
        this.formStore = createFormStore();
        this.callId = crypto.randomUUID(); // this browser API only works on localhost and over https
    }
    connectedCallback() {
        setEnv(`${this.env}${this.legacyApi ? "Legacy" : ""}`);
        this.config = getEnvConfig();
        this.publicApiClient = getPublicApiClient(this.config);
        this.unsubscribeToTbdbToken = this.publicApiClient.subscribeToTbdbToken((event) => {
            if (event.success) {
                loadFormDataFromPublicApi(this.apiStore, this.publicApiClient);
            }
            else {
                this.tbdbError = event.errorMessage || "Error getting TBDB token";
            }
        });
        this.assetManagementApiClient = getAssetManagementApiClient(this.config);
        this.loadTranslations();
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.unsubscribeAuth = whenAuthenticated(() => loadFormDataFromAssetManagementApi(this.apiStore, this.assetManagementApiClient));
        this.apiStore.onChange("notificationTypesLoading", (notificationTypesLoading) => {
            var _a;
            if (!notificationTypesLoading) {
                this.formStore.state.selectedNotificationType = ((_a = this.prefillData) === null || _a === void 0 ? void 0 : _a.notificationType) || null;
            }
        });
    }
    disconnectedCallback() {
        this.unsubscribeAuth();
        i18nProvider.unsubscribe(this.i18nSubscriberId);
        if (this.unsubscribeToTbdbToken) {
            this.unsubscribeToTbdbToken();
        }
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    onPrefillDataChange() {
        var _a;
        const notificationType = (_a = this.prefillData) === null || _a === void 0 ? void 0 : _a.notificationType;
        if (notificationType) {
            this.formStore.state.selectedNotificationType = notificationType;
        }
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    onSubmit(event) {
        var _a;
        event.preventDefault();
        const { softwares } = this.apiStore.state;
        const { form, callId, origin, formStore } = this;
        const data = createRequestData({
            form,
            callId,
            softwares,
            origin: ((_a = this.prefillData) === null || _a === void 0 ? void 0 : _a.origin) || origin,
            selectedMachineTechnology: formStore.state.selectedMachineTechnology
        });
        const files = this.fileUpload
            ? Array.from(form.querySelectorAll("input[type='file']")).reduce((acc, input) => {
                return acc.concat(Array.from(input.files || []));
            }, [])
            : [];
        this.serviceCaseSubmit.emit({ data, callId, files });
        formStore.state.formIsSubmitted = true;
        if (this.config.logging) {
            // eslint-disable-next-line no-console
            console.log("Form submitted", data);
        }
    }
    onCancel() {
        this.serviceCaseCancel.emit();
    }
    render() {
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        const { isAllowedToCreateCase, loading } = this.apiStore.state;
        const { isAuthenticating, authError } = this.authStore.state;
        const { prefillData, multipleSteps } = this;
        const { showErrorNumbers, formIsSubmitted, showMachines } = this.formStore.state;
        const showContent = isAllowedToCreateCase && !(loading || isAuthenticating || authError);
        return (h(Host, { key: 'c51adfbf7f77661540fc3828537a5511abf62a5d' }, !formIsSubmitted && (h("ux-form", { key: '611bda70473c5253a80efb9cba59969a8cd5a3b2', "data-validation-required--msg": t("validation.requiredField") }, h(FormSteps, { key: 'e4999aefe4c30648e23cdfbea781b60a3f8a20a5', multipleSteps: multipleSteps }, h("form", { key: 'db615dfc5db7241cd161f3899a45ef43fd442d5b', onSubmit: (e) => this.onSubmit(e), ref: (el) => (this.form = el) }, h("div", { key: '41fc9a0f0d9cca4044a245c3446d6ffb209ddda5', class: "ux-u-text-align--center ux-u-margin-top-60 ux-u-margin-bottom-60" }, h("div", { key: '0482118e67293d7097a00c9cb36e0cb152fb3473', class: "ux-text-headline ux-text-headline--giant" }, t("headline.createCase"))), (loading || isAuthenticating) && (h("ux-loader", { key: 'ddb130e10513ed65221c25c6ea11c6fa9e1985aa', class: "ux-u-margin-bottom-40", variant: "spinner" })), authError && (h("div", { key: '3b5b92e1b2aada94fc6231512121bdc04d20229b', class: "ux-u-text-align--center ux-text-normal ux-u-margin-top-20 ux-u-margin-bottom-20" }, t("auth.error"))), isAllowedToCreateCase === false && (h("div", { key: '0d0babe70511df4ec743b7c421dbc521350b24d0', class: "ux-u-text-align--center ux-text-normal ux-u-margin-top-20 ux-u-margin-bottom-20" }, t("missingAuthorization"))), h("div", { key: '974fa0a0e7a66c7c23ac098ff8a78ab83deb747a', style: { display: showContent ? "block" : "none" } }, h(FormStep, { key: 'ebcc8d234dc28dea3315246d0fc875dc327cf263', multipleSteps: multipleSteps }, h(StepNavigation, { key: 'cfea0b6f20142c91fb2bc81e761574f4cc9eeb75', t: t, multipleSteps: multipleSteps, currentStep: 1 }), h("div", { key: '7aced95454e166b413800af61168ce5e0c9c3387', class: "ux-row ux-u-flex-jc-center" }, h("div", { key: '985e1954a04060c0be0789f3446d54117f80dc93', class: "ux-col-12 ux-col-md-10" }, h("div", { key: '3665054ca8a45e4f32328c11f5d4fd1b091361f8', class: "ux-row" }, h("div", { key: '7d9a2be4c3fbf5dc561ef1ef3fafdc82d52822d4', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '44d45dabc06dff145096e77c5c653fccab23b45b', class: "ux-u-margin-bottom-20" }, h(NotificationTypeSelect, { key: '0d2e928b91e921e29f0ddf4342bd70f85e2f6ed5', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))), showMachines && (h("div", { key: '68bbf98d17a833d530117587e15cab85adee95c1', class: "ux-col-12 ux-col-md-6" }, h("div", { key: '4e477ea600083f35a4ea72074f6584889fe15d72', class: "ux-u-margin-bottom-20" }, h(MachineSelect, { key: '852f94b6cd250a3ca9eb752f24949a04659136c3', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }))))), h(ApplicationSelectGroup, { key: '8c1ac38f029739990f77d958faf414e45b27f771', t: t, apiStore: this.apiStore, formStore: this.formStore, form: this.form, prefillData: prefillData }), h(SoftwareInputs, { key: '2a0cddd2c81f6c0e49a6cc8fb3d0dcbde80fa46c', t: t, prefillData: prefillData, formStore: this.formStore, apiStore: this.apiStore }), showErrorNumbers && (h("div", { key: 'b04cbc4e98ff34595d38e17343953cd35b333ba3', class: "ux-row" }, h("div", { key: '62f75713d513d3103c80833a11c5fdcca3f88eb4', class: "ux-col-12" }, h(ErrorNumberInput, { key: '43308d2b79197cae885e39ea11f006f2b537d42f', t: t, formStore: this.formStore, prefillData: prefillData })))), h("div", { key: '9a6916d3567f5aea2f52e3224edff8c83002ecf1', class: "ux-row" }, h("div", { key: 'f4984825cbd2dfcd249879821c333f749617ea64', class: "ux-col-12" }, h("div", { key: '184719e6975c436ffb4152556d333831b9e4d33f', class: "ux-u-margin-bottom-20" }, h(DescriptionInput, { key: 'd451417f16dba2fbbaa1ed66a13bbefc9234985c', t: t, prefillData: prefillData })))), this.fileUpload && (h("div", { key: 'b6be72995f8b7044f0297b358383bb1c0f77ec45', class: "ux-row" }, h("div", { key: 'a03c1f4acafba0856676870ae725763045d07d50', class: "ux-col-12" }, h("div", { key: 'd6c35d099ef4e869d4dafb61d59870eee7c71280', class: "ux-u-margin-bottom-20" }, h("ux-file-upload", { key: '1ce02f277a24d9073f070633b0326353fa4937c1', "max-file-size": "50", label: t("field.fileUpload.label"), "accepted-files": "image/*,application/*,text/*,video/mp4,", "max-files": "4" }), h("p", { key: '7a77c355aa3826076c4f45b62f6f6f2c39a0a456', class: "ux-text-tiny" }, t("field.fileUpload.info")))))), h(StepNext, { key: '17259fe8196544cb8907267c6a6b5234836d4d99', t: t, multipleSteps: multipleSteps, onCancel: () => this.onCancel() })))), h(FormStep, { key: 'f247dcc554f266685eb39aefe80d1317f539002f', multipleSteps: multipleSteps }, h(StepNavigation, { key: 'e39256ff4f7bec209985c04937b924cbd0b9e8c6', t: t, multipleSteps: multipleSteps, currentStep: 2 }), h("div", { key: '17e5d2c067f1eb7e1278ffbfa62295042c6381df', class: "ux-row ux-u-flex-jc-center" }, h("div", { key: 'c2953c69fb625e4fe919e4a00771a04cc912d96d', class: "fields-wrapper ux-col-12 ux-col-md-10" }, h("div", { key: '71a3a80a93a951530a7b3754a29b52c2c40c2f2d' }, h("slot", { key: '98e141373781bf03594cbda614ad5899abe9073b', name: "contacts-button" })), h(ContactInputs, { key: '29ef4815851409576431d83fbb99b5101877e055', t: t, apiStore: this.apiStore, locale: this.locale }), h("div", { key: 'c7695802c7931aa20493b7952715979a36c32a0f', class: "ux-u-margin-bottom-20" }, h("div", { key: 'c8e34c3de9689ded2d674719a61099b76e76a9ed', class: "ux-text-normal ux-text-normal--light-gray" }, h("p", { key: '174ff77726731eeedbd5298f4491e051c2b25996' }, t("validation.requiredFieldsExplanation")))), h("div", { key: '0898f2cfb4bbc1f58619d468a5b1d796adbac9b2', class: "ux-u-d-flex ux-u-flex-jc-between ux-u-flex-dir-row-reverse" }, h("ux-button", { key: '36349655ff9a2e2c31e9fece80e573c50d178859', type: "submit", variant: "primary" }, t("button.submit")), h(StepBack, { key: 'b1c88d8e536e25dfba32cd919638e166d9fc7378', t: t, multipleSteps: multipleSteps }), !multipleSteps && (h("ux-button", { key: 'c7683fd24d340946f645626e941f12f5db7a332f', type: "button", onClick: () => this.onCancel(), formnovalidate: true }, t("button.cancel")))))))))))), h("div", { key: '2676a2578478cfaaa41a1f435df6367d9fc604e8', style: { display: formIsSubmitted ? "block" : "none" } }, h("slot", { key: '45f0b84eca438c4f346da7a8faeca37d43419041', name: "connector" })), h(SilentAuth, { key: 'c620970ab3cf1ec26c035c2ef73c46354367776c', config: this.config, disabled: this.disableSilentAuth, authStore: this.authStore })));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"],
        "prefillData": ["onPrefillDataChange"]
    }; }
};
MfCreateServiceCase.style = createServiceCaseCss;

export { MfCreateServiceCase as mf_create_service_case };
//# sourceMappingURL=mf-create-service-case.entry.js.map

//# sourceMappingURL=mf-create-service-case.entry.js.map